// document.addEventListener("DOMContentLoaded", function () {
//     const path = window.location.pathname;

//     if (path.includes("policies/shipping-policy")) {
//       let titleElement = document.querySelector(".shopify-policy__title h1");
//       if (titleElement) {
//         titleElement.textContent = "Shipping and Return Policy";
//       }
//     }
//   });

function hideNinety9ProgressBar() {
    const isMiniCart = document.querySelector('.cart-drawer');
    const isCartPage = document.querySelector('.template-cart');

    if (!isMiniCart && !isCartPage) return;

    const productOptions = document.querySelectorAll('.product-option');
    const miniCartDrawer = document.getElementById('progress-bar-ninety9-drawer');
    const cartPageBlock = document.getElementById('progress-bar-ninety9-block-cart');

    let shouldHide = false;

    productOptions.forEach(option => {
      if (option.textContent.toLowerCase().includes('monthly subscription')) {
        shouldHide = true;
      }
    });

    if (shouldHide) {
      if (miniCartDrawer) miniCartDrawer.style.display = 'none';
      if (cartPageBlock) cartPageBlock.style.display = 'none';
    } else {
      if (miniCartDrawer) miniCartDrawer.style.display = '';
      if (cartPageBlock) cartPageBlock.style.display = '';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Run initially
    hideNinety9ProgressBar();

    // Set up observer for dynamic updates
    const targetNode = document.querySelector('.cart-drawer') || document.querySelector('.template-cart');
    if (!targetNode) return;

    const observer = new MutationObserver(() => {
      hideNinety9ProgressBar();
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  });

// document.addEventListener("DOMContentLoaded", function () {
//   const tooltipText = "Your pet's microbiome is the community of tiny organisms, like good bacteria, living in their gut that are essential for health.";

//   function walk(node) {
//     if (node.nodeType === 3) {
//       const regex = /\bmicrobiome\b/gi;
//       if (regex.test(node.nodeValue)) {
//         const span = document.createElement("span");
//         span.innerHTML = node.nodeValue.replace(regex, function(match) {
//           return `<span class="tooltip-word" data-tooltip="${tooltipText}">${match}</span>`;
//         });
//         node.parentNode.replaceChild(span, node);
//       }
//     } else if (
//       node.nodeType === 1 &&
//       node.nodeName !== "SCRIPT" &&
//       node.nodeName !== "STYLE" &&
//       node.nodeName !== "TEXTAREA"
//     ) {
//       Array.from(node.childNodes).forEach(walk);
//     }
//   }

//   walk(document.body);
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const isAppleDevice = /Mac|iPhone|iPod|iPad/.test(navigator.platform);
//   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
//     console.log("✅ Apple Pay is available - Shopify will render it.");
//   } else {
//     console.log("❌ Apple Pay not available - Shopify will show Shop Pay or fallback.");
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.template-product .rich-text.plentum-bg .hero__text p a[href="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // prevent jumping to top instantly
      window.scrollTo({
        top: 40,
        behavior: "smooth"
      });
    });
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   const checkBadge = setInterval(function() {
//     const container = document.querySelector(".wt-product__info .jdgm-prev-badge__text");
//     if (container) {
//       // Prevent adding multiple times
//       if (!container.nextElementSibling || container.nextElementSibling.tagName !== "A") {
//         const link = document.createElement("a");
//         link.href = "#benifits-reviews";
//         link.textContent = " See Reviews";
//         link.style.marginLeft = "6px";
//         container.insertAdjacentElement("afterend", link);
//       }
//       clearInterval(checkBadge); // stop checking once added
//     }
//   }, 500); // check every 0.5s
// });

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260623_JS: blog/article-only table wrapper. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function getColumnCount(table) {
    var row = table.tHead && table.tHead.rows && table.tHead.rows[0] ? table.tHead.rows[0] : table.rows && table.rows[0];
    return row && row.cells ? row.cells.length : 0;
  }

  function enhancePlentumArticleTables() {
    if (!isArticleTemplate()) return;
    var tables = document.querySelectorAll('main table, article table, .rte table, .article-template table');
    tables.forEach(function (table) {
      if (!table || table.closest('.plentum-table-scroll')) return;
      var columns = getColumnCount(table);
      var wrapper = document.createElement('div');
      wrapper.className = 'plentum-table-scroll' + (columns >= 4 ? ' plentum-wide-table' : '');
      wrapper.setAttribute('data-plentum-columns', String(columns || 0));
      wrapper.style.setProperty('--plentum-table-min-width', Math.min(Math.max((columns || 4) * 168, 680), 1160) + 'px');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePlentumArticleTables);
  } else {
    enhancePlentumArticleTables();
  }
})();

/* PLENTUM_BLOG_NUMBERED_STRUCTURE_FIX_20260819: repair legacy split list/heading markup at render time. */
(function () {
  var ARTICLE_ROOT_SELECTOR = '.main-article__body .article-content';
  var NUMBER_ONLY = /^(\d{1,3})\s*[.)]?$/;
  var STRUCTURAL_TAGS = /^(H[1-6]|P|DIV|BLOCKQUOTE)$/;

  function normalizedText(node) {
    return (node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isEmptyStructuralNode(node) {
    return !!node && STRUCTURAL_TAGS.test(node.tagName || '') && !normalizedText(node) && !node.querySelector('img, video, iframe, table, svg');
  }

  function nextContentSibling(node) {
    var candidate = node ? node.nextElementSibling : null;
    while (candidate && isEmptyStructuralNode(candidate)) {
      var empty = candidate;
      candidate = candidate.nextElementSibling;
      empty.remove();
    }
    return candidate;
  }

  function mergeNumberWithFollowingBlock(numberNode, followingNode, number) {
    if (!numberNode || !followingNode || !STRUCTURAL_TAGS.test(followingNode.tagName || '')) return false;
    var followingText = normalizedText(followingNode);
    if (!followingText || followingText.length > 320 || NUMBER_ONLY.test(followingText)) return false;

    var label = String(number) + '. ';
    if (/^H[1-6]$/.test(numberNode.tagName || '')) {
      numberNode.innerHTML = label + followingNode.innerHTML.trim();
    } else {
      numberNode.innerHTML = '<strong>' + String(number) + '.</strong> ' + followingNode.innerHTML.trim();
    }
    numberNode.setAttribute('data-plentum-structure-repaired', 'split-numbered-block');
    followingNode.remove();
    return true;
  }

  function repairKnownSequenceDefects(root) {
    var path = window.location.pathname || '';

    if (path.indexOf('/best-calming-supplements-for-dogs-with-anxiety-2026-guide-1') !== -1) {
      var tocBlocks = Array.prototype.slice.call(root.querySelectorAll('p'));
      tocBlocks.forEach(function (node, index) {
        if (normalizedText(node) !== '5.') return;
        var next = nextContentSibling(node);
        if (next && normalizedText(next) === '6.') {
          node.remove();
          next.textContent = '5.';
        }
      });
    }

    if (path.indexOf('/siberian-husky-gas-7-common-causes-and-vet-approved-fixes') !== -1) {
      Array.prototype.slice.call(root.querySelectorAll('h2, h3')).forEach(function (heading) {
        var text = normalizedText(heading);
        if (text === '6. Senior Huskies Need Extra Help') {
          heading.textContent = '5. Senior Huskies Need Extra Help';
          heading.setAttribute('data-plentum-structure-repaired', 'number-sequence');
        } else if (text === "7. Red Flags You Shouldn't Ignore") {
          heading.textContent = 'When to Call Your Veterinarian';
          heading.setAttribute('data-plentum-structure-repaired', 'number-sequence');
        }
      });
    }

    if (path.indexOf('/daily-dog-gut-health-routine') !== -1) {
      var truncatedHeadings = Array.prototype.slice.call(root.querySelectorAll('h2, h3')).filter(function (heading) {
        return normalizedText(heading) === 'Probiotic vs.';
      });
      if (truncatedHeadings[0]) {
        truncatedHeadings[0].textContent = 'Probiotics, Prebiotics, and Postbiotics';
        truncatedHeadings[0].setAttribute('data-plentum-structure-repaired', 'truncated-heading');
      }
      if (truncatedHeadings[1]) {
        truncatedHeadings[1].textContent = 'How to Combine Daily Gut Support';
        truncatedHeadings[1].setAttribute('data-plentum-structure-repaired', 'truncated-heading');
      }
    }

    if (path.indexOf('/probiotics-for-dogs-with-itchy-skin') !== -1) {
      var repeatedArticleTitles = Array.prototype.slice.call(root.querySelectorAll('h2')).filter(function (heading) {
        return normalizedText(heading) === 'Probiotics for Dogs with Itchy Skin: What the Science Says';
      });
      if (repeatedArticleTitles.length > 1) repeatedArticleTitles[0].remove();
    }
  }

  function repairArticleStructure() {
    document.querySelectorAll(ARTICLE_ROOT_SELECTOR).forEach(function (root) {
      repairKnownSequenceDefects(root);

      Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div, blockquote')).forEach(function (node) {
        if (!node.isConnected || !node.parentElement || node.closest('li, table, figure, figcaption, .referance-sidebar')) return;
        var match = normalizedText(node).match(NUMBER_ONLY);
        if (!match) return;
        var following = nextContentSibling(node);
        if (following && NUMBER_ONLY.test(normalizedText(following))) {
          node.remove();
          return;
        }
        mergeNumberWithFollowingBlock(node, following, match[1]);
      });

      Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (heading) {
        if (isEmptyStructuralNode(heading)) heading.remove();
      });

      Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (paragraph) {
        if (isEmptyStructuralNode(paragraph)) paragraph.remove();
      });

      Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (heading) {
        if (normalizedText(heading) === '6. Gut dog gut health guide Imbalance') {
          heading.textContent = '6. Gut Microbiome Imbalance';
          heading.setAttribute('data-plentum-structure-repaired', 'corrupted-heading-text');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairArticleStructure);
  } else {
    repairArticleStructure();
  }
})();

/* PLENTUM_BLOG_DUPLICATE_TITLE_CHROME_FIX_20260819:
 * Remove legacy page-template fragments that were accidentally captured inside
 * article.content. Keep the real article template, FAQ questions, inline topic
 * references, and meaningful key-takeaway bullets intact.
 * Shopify GitHub sync retry: 2026-08-19T15:04Z.
 */
(function () {
  function normalizedValue(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizedNodeText(node) {
    return normalizedValue(node && node.textContent ? node.textContent : '');
  }

  function removeNode(node, counters, counterName) {
    if (!node || !node.isConnected) return;
    node.remove();
    counters[counterName] = (counters[counterName] || 0) + 1;
  }

  function outerArticleBody() {
    return Array.prototype.slice.call(document.querySelectorAll('.main-article__body')).find(function (body) {
      return !body.parentElement || !body.parentElement.closest('.main-article__body');
    });
  }

  function recordCleanup(body, counters) {
    var totals = {};
    var previous = body.getAttribute('data-plentum-title-chrome-cleanup') || '';
    previous.split(',').forEach(function (entry) {
      var match = entry.match(/^([^:]+):(\d+)$/);
      if (match) totals[match[1]] = (totals[match[1]] || 0) + Number(match[2]);
    });
    Object.keys(counters).forEach(function (name) {
      totals[name] = (totals[name] || 0) + counters[name];
    });
    var summary = Object.keys(totals).sort().map(function (name) {
      return name + ':' + totals[name];
    }).join(',');
    body.setAttribute('data-plentum-title-chrome-cleanup', summary || 'clean');
  }

  function cleanCapturedArticleChrome() {
    if (!document.body || !/\btemplate-article/.test(document.body.className || '')) return;

    var body = outerArticleBody();
    var pageTitle = document.querySelector('h1.main-article__title[itemprop="headline"], h1.main-article__title');
    var titleValue = normalizedNodeText(pageTitle);
    if (!body || !titleValue) return;

    var counters = {};

    Array.prototype.slice.call(body.querySelectorAll('header')).forEach(function (header) {
      if (header.querySelector('.main-article__title, .main-article__header')) {
        removeNode(header, counters, 'legacy-headers');
      }
    });

    Array.prototype.slice.call(body.querySelectorAll('.article-template__comment-wrapper')).forEach(function (wrapper) {
      removeNode(wrapper, counters, 'captured-comment-wrappers');
    });
    Array.prototype.slice.call(body.querySelectorAll('form.comment-form')).forEach(function (form) {
      removeNode(form, counters, 'captured-comment-forms');
    });

    Array.prototype.slice.call(body.querySelectorAll('.main-article__pic')).forEach(function (picture) {
      removeNode(picture, counters, 'captured-featured-images');
    });

    Array.prototype.slice.call(body.querySelectorAll('.shopify-app-block')).forEach(function (block) {
      if (block.querySelector('.ruffruff-table-of-contents') || /table[_-]of[_-]contents/i.test(block.id || '')) {
        removeNode(block, counters, 'captured-toc-blocks');
      }
    });

    Array.prototype.slice.call(body.querySelectorAll('#ruffruff-table-of-contents small')).forEach(function (credit) {
      removeNode(credit, counters, 'ruffruff-credit-rows');
    });

    Array.prototype.slice.call(body.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (heading) {
      if (heading.closest('.article-faq')) return;
      if (normalizedNodeText(heading) === titleValue) {
        removeNode(heading, counters, 'duplicate-title-headings');
      }
    });

    var path = window.location.pathname || '';
    var knownNearDuplicates = [];
    if (path.indexOf('/dog-allergies-supplements') !== -1) {
      knownNearDuplicates.push('How to Know if Your Dog\'s Allergies Are Linked to Gut...');
    }
    if (path.indexOf('/postbiotic-vs-probiotic-for-dogs') !== -1) {
      knownNearDuplicates.push('Postbiotic vs. Postbiotic For Dogs: The Key Differences Explained');
    }
    if (knownNearDuplicates.length) {
      Array.prototype.slice.call(body.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (heading) {
        if (heading.closest('.article-faq')) return;
        if (knownNearDuplicates.some(function (value) { return normalizedNodeText(heading) === normalizedValue(value); })) {
          removeNode(heading, counters, 'near-duplicate-title-headings');
        }
      });
    }

    Array.prototype.slice.call(body.querySelectorAll('.plentum-key-takeaways')).forEach(function (box) {
      Array.prototype.slice.call(box.querySelectorAll('p, strong, li')).forEach(function (node) {
        if (normalizedNodeText(node) === titleValue) {
          removeNode(node, counters, 'redundant-key-takeaway-titles');
          return;
        }
        var text = node.textContent || '';
        if (/!important|::before|::after|\{\s*content\s*:/i.test(text)) {
          removeNode(node, counters, 'leaked-stylesheet-blocks');
        }
      });
      if (box.isConnected && normalizedNodeText(box) === 'key takeaways') {
        removeNode(box, counters, 'empty-key-takeaway-boxes');
      }
    });

    Array.prototype.slice.call(body.querySelectorAll('.ruffruff-table-of-contents-list-item-anchor')).forEach(function (link) {
      if (normalizedNodeText(link) !== titleValue) return;
      var item = link.closest('li');
      removeNode(item || link, counters, 'duplicate-title-toc-links');
    });

    var recommendationLabels = [
      'recommended reading',
      'related reading',
      'related articles',
      'explore more',
      'read more'
    ];
    Array.prototype.slice.call(body.querySelectorAll('.internal-links, .related-reading')).forEach(function (section) {
      var heading = section.querySelector('h2, h3, h4, h5, h6');
      if (!heading || recommendationLabels.indexOf(normalizedNodeText(heading)) === -1) return;

      var content = section.cloneNode(true);
      Array.prototype.slice.call(content.querySelectorAll('h2, h3, h4, h5, h6')).forEach(function (contentHeading) {
        if (recommendationLabels.indexOf(normalizedNodeText(contentHeading)) !== -1) {
          contentHeading.remove();
        }
      });
      var hasRecommendation = !!content.querySelector('a[href], img, video, iframe, svg');
      if (!hasRecommendation && !normalizedNodeText(content)) {
        removeNode(section, counters, 'empty-recommendation-shells');
      }
    });

    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (paragraph) {
      if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe, svg, table')) {
        removeNode(paragraph, counters, 'empty-paragraphs');
      }
    });

    recordCleanup(body, counters);
  }

  function runArticleCleanupSequence() {
    cleanCapturedArticleChrome();
    var cleanupInterval = window.setInterval(cleanCapturedArticleChrome, 500);
    window.setTimeout(function () {
      window.clearInterval(cleanupInterval);
      cleanCapturedArticleChrome();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runArticleCleanupSequence);
  } else {
    runArticleCleanupSequence();
  }
  window.addEventListener('load', function () {
    window.setTimeout(cleanCapturedArticleChrome, 0);
  });
})();

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260623_V2_JS: article-only table metadata upgrade. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function getColumnCount(table) {
    var row = table.tHead && table.tHead.rows && table.tHead.rows[0] ? table.tHead.rows[0] : table.rows && table.rows[0];
    return row && row.cells ? row.cells.length : 0;
  }

  function markDensePlentumTables() {
    if (!isArticleTemplate()) return;
    document.querySelectorAll('.plentum-table-scroll table').forEach(function (table) {
      var columns = getColumnCount(table);
      var wrapper = table.closest('.plentum-table-scroll');
      if (!wrapper) return;
      wrapper.setAttribute('data-plentum-columns', String(columns || 0));
      if (columns >= 4) wrapper.classList.add('plentum-wide-table');
      if (columns >= 5) wrapper.classList.add('plentum-dense-table');
      if (!wrapper.style.getPropertyValue('--plentum-table-min-width')) {
        wrapper.style.setProperty('--plentum-table-min-width', Math.min(Math.max((columns || 4) * 180, 920), 1180) + 'px');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDensePlentumTables);
  } else {
    markDensePlentumTables();
  }
})();

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260624_V3_JS: article-only overflow containment and no-th header fallback. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function markTables() {
    if (!isArticleTemplate()) return;
    document.querySelectorAll('.plentum-table-scroll').forEach(function (wrapper) {
      var table = wrapper.querySelector('table');
      if (!table) return;
      wrapper.classList.toggle('plentum-no-th-table', !table.querySelector('th'));
      var rect = wrapper.getBoundingClientRect();
      var overflowsViewport = rect.left < 0 || rect.right > (window.innerWidth || document.documentElement.clientWidth || 0);
      wrapper.classList.toggle('plentum-contained-table', overflowsViewport);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markTables);
  } else {
    markTables();
  }
  window.addEventListener('resize', markTables);
})();


/* T-VRSYS (2026-10-14, VR-01/05): (a) FAQ answers in section#faq become accessible accordion cards (details/summary around the same h3 and p;
   text and the FAQPage JSON-LD are untouched). (b) Every .plentum-table-scroll table gets .blg-stack and data-label per cell so phones show labeled cards. */
(function () {
  'use strict';
  function faqAccordion() {
    var sections = document.querySelectorAll('section#faq');
    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.querySelector('details.faq-item')) return;
      var kids = Array.prototype.slice.call(sec.children);
      var i = 0;
      while (i < kids.length) {
        var h = kids[i];
        if (h.tagName === 'H3') {
          var group = [];
          var j = i + 1;
          while (j < kids.length && /^(P|UL|OL|DIV|TABLE|BLOCKQUOTE|ASIDE)$/.test(kids[j].tagName)) { group.push(kids[j]); j++; }
          if (group.length) {
            var d = document.createElement('details');
            d.className = 'faq-item';
            var s = document.createElement('summary');
            sec.insertBefore(d, h);
            s.appendChild(h);
            d.appendChild(s);
            group.forEach(function (n) { d.appendChild(n); });
          }
          i = Math.max(j, i + 1);
        } else { i++; }
      }
    });
  }
  function stackTables() {
    // Tables in rich-text page bodies (.ol__body) get the same frame as article tables; the compare table frame (.sci-tablewrap) joins too.
    Array.prototype.forEach.call(document.querySelectorAll('.ol__body table'), function (t) {
      if (t.closest('.plentum-table-scroll')) return;
      var f = document.createElement('div');
      f.className = 'plentum-table-scroll';
      t.parentNode.insertBefore(f, t); f.appendChild(t);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.sci-tablewrap'), function (f) { f.classList.add('plentum-table-scroll'); });
    Array.prototype.forEach.call(document.querySelectorAll('.plentum-table-scroll'), function (w) {
      var t = w.querySelector('table');
      if (!t || w.classList.contains('blg-stack') || !t.tBodies.length) return;
      if (t.tFoot || t.querySelector('[rowspan]') || t.querySelector('thead [colspan]')) return;
      var rows = Array.prototype.slice.call(t.rows);
      var headRow = t.tHead && t.tHead.rows[0] ? t.tHead.rows[0] : null;
      var first = t.tBodies[0].rows[0];
      if (!headRow && first && first.cells.length > 1 && !first.querySelector('td')) { headRow = first; first.classList.add('blg-stack-hr'); }
      var labels = [];
      if (headRow) Array.prototype.forEach.call(headRow.cells, function (c, k) { labels[k] = (c.textContent || '').replace(/\s+/g, ' ').trim(); });
      rows.forEach(function (r) {
        if (r === headRow || (t.tHead && r.parentNode === t.tHead)) return;
        var simple = true;
        Array.prototype.forEach.call(r.cells, function (c) { if (c.colSpan > 1) simple = false; });
        Array.prototype.forEach.call(r.cells, function (c, k) {
          if (simple && c.tagName === 'TD' && k > 0 && labels[k]) c.setAttribute('data-label', labels[k]);
        });
      });
      w.classList.add('blg-stack');
      if (rows.reduce(function (m, r) { return Math.max(m, r.cells.length); }, 0) >= 6) w.classList.add('blg-stack-all');
    });
  }
  function run() { try { faqAccordion(); stackTables(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
